import { Box, Image } from '@jfs/ui-new'
import { memo, useMemo } from 'react'
import { useIsMobile } from '../../../util/useFontSize'
import { QRCode } from './QrCode'
import { styles } from './styles'
import { UpiDetail } from './UpiDetail'
const ChicMicLightStrip = require('../../../assets/images/svg/JioPay-Strip.svg')

interface QRCodeViewInterface {
  loading?: boolean
  qrImage: string
  vpa: string
  merchantName: string
}

const QRCodeView = memo(({ qrImage, vpa, merchantName }: QRCodeViewInterface) => {
  const memoisedLightStrip = useMemo(() => <Image source={ChicMicLightStrip} width={'100%'} height={63} />, [])
  const isMobile = useIsMobile()
  return (
    <Box {...styles.container(isMobile)}>
      <Box {...styles.upiViewContainer}>
        <Box {...styles.imageContainer}>{memoisedLightStrip}</Box>
        <Box {...styles.qrImgContainer}>
          <QRCode qrImage={qrImage} />
        </Box>
      </Box>
      <UpiDetail vpa={vpa} merchantName={merchantName} />
    </Box>
  )
})
export { QRCodeView }
